
import WDElement from '../gui/wd-element';
import WDElementCollapsible from '../gui/wd-element-collapsible';
import WDButton from '../gui/button/wd-button';
import { WDFormText } from '../gui/form/wd-form-text';
import { WDFormPassword } from '../gui/form/wd-form-password';
import WDList from '../gui/lists/wd-list';

export default class WDKeypad extends WDElement
{

	#options = {
		placeholder: null,
		handler: null,
		change: null,
		type: 'password',
		title: null,
	};

	#enterBtn = null;
	#title = null;
	#keyForm = null;
	#body = null;
	#keypad = null;
	#resultList = null;

	constructor(opts)
	{
		super('<div class="wd-keypad"/>');

		if (opts) Object.assign(this.#options, opts);

		if (opts?.inputType == 'password')
		{
			this.#keyForm = new WDFormPassword({ name: 'keypad', placeholder: this.#options.placeholder });
		}
		else
		{
			this.#keyForm = new WDFormText({ name: 'keypad', placeholder: this.#options.placeholder });
		}

		this.#keyForm.on('change', (evt) => this.handleChange(evt));
		this.#keyForm.on('keyup', (evt) => this.handleKeyUp(evt));

		let clearBtn = wdc('<span class="fa-solid fa-times"/>');
		this.#keyForm.suffix.append(clearBtn);
		this.#keyForm.suffix.addEventListener('click', () => this.clearForm());

		this.append(this.#keyForm);
		this.keypad;

		this.#keyForm.input.addEventListener('focus', (evt) => this.checkVisibility());

		//the timeout allows us to click a result w/o it sliding out of view
		this.#keyForm.input.addEventListener('focusout', (evt) => setTimeout(() => this.checkVisibility(), 250) );

		if (this.#options?.title) this.title = this.#options?.title;

		return this;
	};

	//accessors
	get enterBtn() { return this.#enterBtn; };

	//
	handleKeyUp(evt)
	{
		if (!evt) evt = window.event;

		if (evt.which == "13") 
		{
			this.handleSubmit(evt);
			return false;
		}

		this.trigger('keypad:keyup', evt);
	};

	clearForm()
	{
		this.#keyForm.value = '';
		this.handleChange();
	};

	get title()
	{
		if (!this.#title)
		{
			this.#title = new WDElementCollapsible();
			this.#title.classList.add('wd-keypad-title');
			this.prepend(this.#title);
		}

		return this.#title;
	};

	set title(str) { this.title.append(str); };

	addResultList(opts)
	{
		if (!this.#resultList)
		{
			this.#resultList = new WDList(opts);
			this.#resultList.classList.add('wd-keypad-list');
			this.keypad.after(this.#resultList);
		}

		return this.#resultList;
	};

	get resultList() { return this.#resultList; };
	set resultList(cfg) { this.addResultList(cfg); };

	get body()
	{
		if (!this.#body)
		{
			this.#body = wdc('<div class="wd-keypad-body"/>');
			this.keypad.append(this.#body);
		}

		return this.#body;
	};

	get value() { return this.#keyForm.value; };
	set value(val) { this.#keyForm.value = val; };

	get keypad()
	{
		if (!this.#keypad)
		{
			this.#keypad = new WDElementCollapsible();
			this.#keypad.classList.add('wd-keypad-pad'); //('<div class="wd-keypad-pad"/>');

			for (let i = 1; i <= 9; i++)
			{
				const btn = new WDButton({ label: i, press: () => this.enterNumber(String(i)) });
				btn.classList.add('btn-default');
				this.#keypad.append(btn);
			}

			const delBtn = new WDButton({ label: 'Delete', theme: 'default', press: () => this.deleteNumber() });
			const zeroBtn = new WDButton({ label: '0', theme: 'default', press: () => this.enterNumber('0') });
			this.#enterBtn = new WDButton({ label: 'Enter', theme: 'default', press: (evt) => this.handleSubmit(evt) });
			this.#keypad.append(delBtn, zeroBtn, this.#enterBtn);

			this.append(this.#keypad);
		}

		return this.#keypad;
	};

	checkVisibility()
	{
		if (document.activeElement == this.#keyForm.input)
		{
			this.hidePad();
		}
		else
		{
			this.showPad();
		}
	};

	hidePad() { this.#keypad.close(); };
	showPad() { console.trace(); this.#keypad.open(); };
	hideTitle() { this.#title.close(); };
	showTitle() { this.#title.open(); };

	handleChange(evt)
	{
		this.trigger('keypad:updated');
	};

	handleSubmit(evt)
	{
		this.trigger('keypad:submitted');
	};

	enterNumber(num)
	{
		this.#keyForm.value = String(this.#keyForm.value) + String(num);
		this.handleChange();
	};

	deleteNumber()
	{
		const str = this.#keyForm.value;
		this.#keyForm.value = str.substr(0, str.length - 1);

		this.handleChange();
	};

	reset()
	{
		this.#keyForm.value = '';
	};
};

customElements.define('wd-keypad', WDKeypad);
